import { ScreenHeader } from 'components'
import React, { useState } from 'react'
import { CreatorTabs } from 'utility'
import { HeaderWrapper } from './dashboard'
import { Tabs } from 'antd'
import { AllViewersTab, BlockedViewersTab } from 'page-components/viewers/list'

export const ViewersScreen = () => {
  const [tab, setTab] = useState(CreatorTabs.UnBlocked)

  return (
    <div>
      <HeaderWrapper>
        <ScreenHeader text="List of Viewers" />
      </HeaderWrapper>
      <div className="px-5">
        <div className="tabs-container">
          <Tabs
            defaultActiveKey={CreatorTabs.UnBlocked}
            activeKey={tab}
            className="custom-tabs"
            centered
            onChange={key => setTab(key)}
            items={[
              {
                key: CreatorTabs.UnBlocked,
                label: 'Viewers',
                children: tab === CreatorTabs.UnBlocked ? <AllViewersTab /> : null,
              },
              {
                key: CreatorTabs.Blocked,
                label: 'Block Viewers',
                children: tab === CreatorTabs.Blocked ? <BlockedViewersTab /> : null,
              },
            ]}
          />
        </div>
      </div>
    </div>
  )
}
